// extracted by mini-css-extract-plugin
export default {"root":"TermsOfUse_root__41t+k","main":"TermsOfUse_main__UzNPy","title":"TermsOfUse_title__e8crh","section":"TermsOfUse_section__S3GQ3"};